import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * "Tech to tech": frases reales de mecánicos en foros públicos (VOC de la
 * ficha DPS64), con fuente. No se presentan como reseñas del producto.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-paper-dark';
  return <section aria-label={title} className={`w-full text-pine ${bg}`} data-id="element-331" data-mp="2x0jnulfopxdx">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-332" data-mp="2x2w32qu25tna">
        <div className="text-center" data-id="element-333" data-mp="2s2rwbsiycda9">
          <p className="eyebrow text-ember-deep" data-id="element-334" data-mp="2s3tba8339jx9">Tech to tech</p>
          <h2 className="trail-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-335" data-mp="v859fwccnb29">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-336" data-mp="h5ya8j4cpl5q">
            Real words from mechanics in public repair forums. This is exactly
            the bench Small Engine Diagnostic Pro was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-337" data-mp="7925mohkpj6g">
          {voices.map(item => <figure key={item.quote} className="trail-card rounded-2xl border border-paper-dark bg-paper p-6" data-id="element-338" data-mp="c7dfgz7vbtoo">
              <QuoteIcon className="h-7 w-7 text-ember" aria-hidden="true" data-id="element-339" data-mp="14w29yfef50rg" />
              <blockquote className="field-note mt-2 text-[30px] uppercase leading-[1.05] text-pine" data-id="element-340" data-mp="14xdh8p72oqnb">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-pine-soft" data-id="element-341" data-mp="v44xl5boc2r5">
                <span className="block text-[13px] font-bold text-pine" data-id="element-342" data-mp="1iusay64czkl3">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-pine-muted" data-id="element-343" data-mp="1xhh4zsfud5k3">
          Quoted as written from public small engine repair forums. Not reviews
          of this product.
        </p>
      </div>
    </section>;
}